<template>
  <!-- 스펙234_개선_13: [고객 조회] 상단 50% 고객정보 + 하단 50% 고객정보 수신 임시 목록 -->
  <div class="page2">
    <h3>광고캐시백 조회 - 고객 조회</h3>

    <div class="half">
      <div class="half-title">고객정보</div>
      <CustomerInquiry ref="top" :hide-title="true" />
    </div>

    <div class="half" v-if="canReceive">
      <div class="half-title">고객 불러오기 완료 임시 목록</div>
      <CustomerReceiveList @applied="onApplied" />
    </div>
  </div>
</template>

<script>
import CustomerInquiry from './CustomerInquiry.vue';
import CustomerReceiveList from './CustomerReceiveList.vue';
import { getAuth } from '../store/auth';

export default {
  name: 'CustomerInquiry2',
  components: { CustomerInquiry, CustomerReceiveList },
  computed: {
    // 스펙234_개선_13: 고객정보 수신 임시 목록은 staff/admin 권한일 때 표시
    canReceive() { const r = getAuth().role; return r === 'admin' || r === 'staff'; }
  },
  methods: {
    onApplied() { if (this.$refs.top && this.$refs.top.reload) this.$refs.top.reload(); }
  }
};
</script>

<style scoped>
.page2 { padding: 4px; }
.page2 > h3 { margin: 4px 0 10px; }
.half { border: 1px solid #e4e9f2; border-radius: 8px; padding: 6px 10px; margin-bottom: 12px; max-height: 46vh; overflow: auto; }
.half-title { font-size: 13px; font-weight: 700; color: #33405c; margin: 4px 2px 6px; }
</style>
